import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';

const flexContainerProps = [
  'flex-direction',
  'flex-wrap',
  'flex-flow',
  'justify-content',
  'align-items',
  'align-content'
];

const flexItemProps = [
  'order',
  'flex-grow',
  'flex-shrink',
  'flex-basis',
  'flex',
  'align-self'
];

const structFlexProps = [
  // Flex Container Props
  ...flexContainerProps,

  // Flex Item Props
  ...flexItemProps
];

const generateProps = (props, type) => {
  let styles = '';
  const newProps = { ...props };

  styles += props.flex
    ? null
    : `flex: 
    ${props.grow || props['flex-grow'] || 0}
    ${props.shrink || props['flex-shrink'] || 1}
    ${props.basis || props['flex-basis'] || 'auto'};`;

  Object.keys(props).forEach(prop => {
    let idx = -1;

    if (prop) {
      if (type.indexOf(prop) > -1) {
        idx = type.indexOf(prop);
      } else if (type.indexOf('flex-'.concat(prop)) > -1) {
        idx = type.indexOf('flex-'.concat(prop));
        delete newProps[prop];
      }

      if (idx > -1) {
        styles += `${type[idx]}: ${props[prop]};`;
      }
    }
  });

  return {
    styles,
    newProps
  };
};

/** Struct Base Component */

const StructBase = React.forwardRef(({ children, ...props }, ref) => (
  <div ref={ref} {...props}>
    {children}
  </div>
));

StructBase.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

StructBase.displayName = 'StructBase';

/** Struct Flex Component */

export const StructFlex = React.forwardRef((oldProps, ref) => {
  const { newProps, styles } = generateProps(oldProps, structFlexProps);
  const CSS = css`
    display: flex;
    ${styles}
  `;

  return <StructBase ref={ref} css={CSS} {...newProps} />;
});

StructFlex.displayName = 'StructFlex';

/** Struct Item Component */

export const StructItem = React.forwardRef((oldProps, ref) => {
  const { newProps, styles } = generateProps(oldProps, flexItemProps);
  const CSS = css`
    ${styles}
  `;

  return <StructBase ref={ref} css={CSS} {...newProps} />;
});

StructItem.displayName = 'StructItem';
